import { useTimezone } from '@/hooks/useTimezone';

type DateTimeTextProps = {
  value: unknown;
  format?: string;
};

export default function DateTimeText({ value, format }: DateTimeTextProps) {
  const { formatDateTime } = useTimezone();
  return <>{formatDateTime(value, format)}</>;
}
